/* eslint-disable */

<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card class="mb-base">
        <div class="fourth-sim pt-0">
          <div class="vx-row mb-4">
            <div class="vx-col w-6/12 flex items-center">
              <h2 class="font-bold">Item</h2>
            </div>
            <div class="vx-col w-6/12 flex items-center">
              <h2 class="font-bold">Response</h2>
            </div>
          </div>
          <div class="vx-row items-center border-white border-2 border-solid rounded p-2 my-4" v-for="item in table_items" :key="item.name">
            <div class="vx-col w-6/12 flex items-center">
              <img draggable="false" class="mr-4" :src="item.image" width="50" />
              <h4 class="font-semibold">{{ item.name }}</h4>
            </div>
            <div class="vx-col w-6/12">
              <v-select
                placeholder="Select a response from the dropdown"
                class="w-full"
                :options="response_options"
                v-model="item.select"
              />
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      table_items: [
        {
          name: 'Hardware Token',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/token.png',
          select_answer: 1,
        },
        {
          name: 'Password',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/key.png',
          select_answer: 2,
        },
        {
          name: 'PIN Number',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/pin-number.png',
          select_answer: 2,
        },
        {
          name: 'Retina Scan',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/retina-scan.png',
          select_answer: 3,
        },
        {
          name: 'Fingerprint Scan',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/finger-print.png',
          select_answer: 3,
        },
        {
          name: 'Smart Card',
          select: null,
          image: 'https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/184752426752933888/smart-id.png',
          select_answer: 1,
        },
      ],

      response_options: [
        { id: 1, label: 'Have' },
        { id: 2, label: 'Know' },
        { id: 3, label: 'Are' },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.table_items.forEach((x) => {
        if (x.select && x.select.id === x.select_answer) {
          totalScore++;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
